import { Checkbox, DateInputRange, Select } from '@ui/src';
import { StatementExportTypes } from '../types';

import cn from './styles.module.css';

const ExportStatement = ({
  selectedCurrency,
  currencies,
  setSelectedCurrency,
  selectedDateType,
  setSelectedDateType,
  selectedDateRange,
  setSelectedDateRange,
  selectedFormat,
  setSelectedFormat,
}: StatementExportTypes) => (
  <>
    <div className={cn.currencyWrapper}>
      <Select
        name="selectedCurrecny"
        title="Currency"
        placeholder="Select currency"
        value={selectedCurrency}
        list={currencies || []}
        onChange={(e) => setSelectedCurrency(e.target.value as string)}
        withClearButton
      />
    </div>
    <div className={cn.rangeTypeWrapper}>
      <div className={cn.rangeTypeTitle}>Select period</div>
      <div className={cn.radioWrapper}>
        <Checkbox
          name="selectedDateType"
          type="radio"
          value="today"
          title="Today"
          checked={selectedDateType === 'today'}
          onChange={() => setSelectedDateType('today')}
        />
      </div>
      <div className={cn.radioWrapper}>
        <Checkbox
          name="selectedDateType"
          type="radio"
          value="week"
          title="Week"
          checked={selectedDateType === 'week'}
          onChange={() => setSelectedDateType('week')}
        />
      </div>
      <div className={cn.radioWrapper}>
        <Checkbox
          name="selectedDateType"
          type="radio"
          value="one-month"
          title="1 Month"
          checked={selectedDateType === 'one-month'}
          onChange={() => setSelectedDateType('one-month')}
        />
      </div>
      <div className={cn.radioWrapper}>
        <Checkbox
          name="selectedDateType"
          type="radio"
          value="two-months"
          title="2 Months"
          checked={selectedDateType === 'two-months'}
          onChange={() => setSelectedDateType('two-months')}
        />
      </div>
      <div className={cn.radioWrapper}>
        <Checkbox
          name="selectedDateType"
          type="radio"
          value="three-months"
          title="3 Months"
          checked={selectedDateType === 'three-months'}
          onChange={() => setSelectedDateType('three-months')}
        />
      </div>
      <div className={cn.radioWrapper}>
        <Checkbox
          name="selectedDateType"
          type="radio"
          value="six-months"
          title="6 Months"
          checked={selectedDateType === 'six-months'}
          onChange={() => setSelectedDateType('six-months')}
        />
      </div>
      <div className={cn.radioWrapper}>
        <Checkbox
          name="selectedDateType"
          type="radio"
          value="year"
          title="1 Year"
          checked={selectedDateType === 'year'}
          onChange={() => setSelectedDateType('year')}
        />
      </div>
      <div className={cn.radioWrapper}>
        <Checkbox
          name="selectedDateType"
          type="radio"
          value="custom"
          title="Custom period"
          checked={selectedDateType === 'custom'}
          onChange={() => setSelectedDateType('custom')}
        />
      </div>
      {selectedDateType === 'custom' && (
        <div
          className={`${cn.dateInputRange} ${
            !selectedDateRange.length ? cn.empty : ''
          }`}
        >
          <div className={cn.dateInputTitle}>Account statement period</div>
          <DateInputRange
            values={selectedDateRange.map((item) => item.toISOString())}
            onChangeRange={(date) => setSelectedDateRange(date)}
            placeholder="Select date"
            withoutTwoPickers
            withoutCustomSelector
          />
        </div>
      )}
    </div>
    <div className={cn.rangeTypeWrapper}>
      <div className={cn.rangeTypeTitle}>Format</div>
      <div className={cn.radioWrapper}>
        <Checkbox
          name="selectedFormat"
          type="radio"
          value="csv"
          title="CSV"
          checked={selectedFormat === 'csv'}
          onChange={() => setSelectedFormat('csv')}
        />
      </div>
      <div className={cn.radioWrapper}>
        <Checkbox
          name="selectedFormat"
          type="radio"
          value="pdf"
          title="PDF"
          checked={selectedFormat === 'pdf'}
          onChange={() => setSelectedFormat('pdf')}
        />
      </div>
    </div>
  </>
);

export default ExportStatement;
